import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'
import { usePromiseQuery } from '../../../../utils/apollo/_helpers/promiseQuery'
import { exportsClient } from '../../../../utils/apollo/api'
import Select from '../../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Exports($search: String, $page: Int, $filter: ExportTemplateFilter) {
    exportTemplates(filter: $filter, page: $page, search: $search, sort: { field: NAME, type: ASC }) {
      id
      name
      configuration
    }
  }
`

export const useExportTemplatesLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: exportsClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'exportTemplates']))
  }
}

const ExportTemplatesSelect = ({ onChange, value, filter, interpolations = [], ...props }) => {
  const getOptions = useExportTemplatesLoader(filter)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      interpolations={interpolations}
      origin="checklist"
      {...props}
    />
  )
}

export default ExportTemplatesSelect
